import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, skip, take, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { AppStateInterface } from "src/app/store/appState.interface";
import { resultLocationPartnerReviewSelector } from "src/app/store/locationPartner/location-partner.selectors";
import { Pager } from "src/app/shared/models/pagination";
import { FilterLastWeekForLPReview } from "src/app/shared/models/location-partners/filterLastWeekForLPReview";
import {
  ExportData,
  exportDataType,
  LocationOverviewData,
} from "src/app/shared/data/exportData";
import { TranslateService } from "@ngx-translate/core";
import {
  invokeLocationPartnerReview,
  resultLocationPartnerReview,
} from "src/app/store/locationPartner/actions/get-impressions.actions";
import { invokeApiDestroyedLocation_overview } from "src/app/store/apiState.interface";
import { catchForbiddenError } from "src/app/store/user/user.actions";
import { catchForbiddenErrorSelector } from "src/app/store/user/user.selectors";
import { Authorities } from "src/app/shared/enum/authorities";
import { JwtService } from "src/app/shared/services/jwt.service";
import { RefreshButtonState } from "src/app/shared/enum/refreshButtonState";
import { FiltersService } from "src/app/shared/services/filters.service";
import { FilterParams } from "src/app/shared/models/filterParams";
import { Constants } from "src/app/shared/data/constants";
@Component({
  selector: "app-location-partner-preview",
  templateUrl: "./location-partner-preview.component.html",
})
export class LocationPartnerPreviewComponent
  extends BaseComponent
  implements OnInit
{
  @Input() loading: boolean | null = false;
  @Input() receivedLocation: ExportData[];
  @Input() title: string;
  @Output("locationPreview") locationPreview = new EventEmitter<ExportData[]>();
  @Output("tableLocationPreview") tableLocationPreview =
    new EventEmitter<any>();
  pagerLocationPartnerPreview: Pager = {
    pageSize: Constants.defaultTableSize,
    pageNumber: 1,
  };
  locationPartnerReview$: Observable<FilterLastWeekForLPReview | null>;
  lastWeekLocationPartnerReview: FilterLastWeekForLPReview | null;
  resultCountLOcationPartnerPreview: number;

  public last7Days: Date[] = [];
  last7DaysString: string[] = [];
  location: ExportData[] = LocationOverviewData;
  cachedAt: Date | null = null;
  catchForbiddenError$: Observable<boolean | null>;
  forbidden: boolean | null = false;
  fetchingLocationPartnerPreviewState: RefreshButtonState =
    RefreshButtonState.IDLE;

  filters: FilterParams | null;
  constructor(
    private store: Store<AppStateInterface>,
    private translate: TranslateService,
    private jwtService: JwtService,
    private filtersService: FiltersService
  ) {
    super(store);
    this.locationPartnerReview$ = this.store
      .pipe(select(resultLocationPartnerReviewSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.getLast7Days();
    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.forbidden = !authorities.includes(Authorities.LP_REVIEW.toString());
    }

    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();

    this.pagerLocationPartnerPreview.pageNumber =
    this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pagerLocationPartnerPreview.pageNumber
    );
    this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pagerLocationPartnerPreview.pageSize
    );
  }

  ngOnInit(): void {
    this.store.dispatch(
      resultLocationPartnerReview({ lastWeekReviewLP: null })
    );
    this.locationPartnerReview$.subscribe(
      (result: FilterLastWeekForLPReview | null) => {
        if (result != null) {
          this.lastWeekLocationPartnerReview = result;
          this.cachedAt = result.cachedAt;
          this.resultCountLOcationPartnerPreview = result.count;
          if (this.pagerLocationPartnerPreview.pageSize == undefined) {
            this.pagerLocationPartnerPreview = {
              ...this.pagerLocationPartnerPreview,
              pageSize: result.count,
            };
          }
          if (this.lastWeekLocationPartnerReview.locationPartnerChecks) {
            const csvRows: string[] = [];
            let headers: string[] = [];
            headers.push(
              this.translate.instant("dashboard.admin.lpReview.companyName")
            );
            this.last7DaysString.map((day) => {
              headers.push(day);
            });
            headers.push(
              this.translate.instant("dashboard.admin.lpReview.averageViews")
            );
            this.lastWeekLocationPartnerReview.locationPartnerChecks.forEach(
              (item) => {
                const row = [item.companyName, item.views, item.average];
                csvRows.push(row.join(","));
              }
            );
            for (let i = 0; i < this.location.length; i++) {
              if (this.location[i].type == exportDataType.LP_REVIEW_ADMIN)
                this.location[i].data = [headers, ...csvRows].join("\n");
            }
            this.locationPreview.emit(this.location);
          }
        } else {
          this.loadData(false);
        }
      }
    );
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
  }

  itemsPerPageChange(pageSize: number) {
    this.pagerLocationPartnerPreview = {
      ...this.pagerLocationPartnerPreview,
      pageSize: pageSize,
    };
    this.loadData(false);
  }
  changePage(event: number) {
    this.pagerLocationPartnerPreview = {
      ...this.pagerLocationPartnerPreview,
      pageNumber: event,
    };
    this.loadData(false);
  }

  getLast7Days() {
    const today = new Date();
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      this.last7Days.push(date);
      this.last7DaysString.push(date.toString());
    }
    this.last7Days;
  }

  loadData(refreshCache: boolean) {
    this.store.dispatch(invokeApiDestroyedLocation_overview());
    this.store.dispatch(
      invokeLocationPartnerReview({
        pager: this.pagerLocationPartnerPreview,
        refreshCache: refreshCache,
      })
    );
  }

  onClickRefreshCache() {
    this.fetchingLocationPartnerPreviewState = RefreshButtonState.LOADING;
    this.store.dispatch(
      invokeLocationPartnerReview({
        pager: {
          ...this.pagerLocationPartnerPreview,
        },
        refreshCache: true,
      })
    );
    this.locationPartnerReview$.pipe(skip(1), take(1)).subscribe((result) => {
      if (result) {
        this.fetchingLocationPartnerPreviewState = RefreshButtonState.SUCCESS;
        setTimeout(
          () =>
            (this.fetchingLocationPartnerPreviewState =
              RefreshButtonState.IDLE),
          2000
        );
      }
    });
  }
}
